var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('b-container',[_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }